import { InjectionToken, Provider } from '@angular/core';

function setImpersonationFlag(): void {
  localStorage.setItem('is-impersonating', 'true');
}

/**
 * Removes the correct item from local storage
 */
export function removeImpersonationFlag(): void {
  localStorage.removeItem('is-impersonating');
}

export const IMPERSONATION_TOKEN = new InjectionToken<{ set: () => void }>(
  'IMPERSONATION_TOKEN',
);

export const IMPERSONATION_PROVIDER: Provider = {
  deps: [],
  provide: IMPERSONATION_TOKEN,
  useFactory: () => ({
    remove: removeImpersonationFlag,
    set: setImpersonationFlag,
  }),
};
